import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'

// ui-kit
import { MainContainer, Row, Col } from '@navent-jobs/ui-kit/components/grid'

// mixins
import { RelacionadasContainer, SectionTitle, LinksContainer, Li, Link, LinkTitle } from './mixins'

// constants
import { ID_PAIS } from '../../../../constants'

// redux
import { setBusquedasRelacionadas } from '../../../../redux/actions/active-aviso'

const BusquedasRelacionadas = ({ activeAviso, activeAvisoStates }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { aviso, busquedasRelacionadas } = activeAviso
  const avisoDifferentFromCountryOrigin = aviso && aviso.localizacion.paisId !== ID_PAIS

  useEffect(() => {
    if (aviso) {
      dispatch(setBusquedasRelacionadas(aviso))
    }
  }, [aviso])

  if ((isEmpty(busquedasRelacionadas) && activeAvisoStates.loading) || avisoDifferentFromCountryOrigin) {
    return null
  }

  return (
    <RelacionadasContainer>
      <MainContainer>
        <Row>
          <Col xl={8}>
            <SectionTitle>{t('fichaAviso.busquedasRelacionadas.title')}</SectionTitle>
          </Col>
        </Row>

        <Row>
          <Col xl={8}>
            {isEmpty(busquedasRelacionadas) ? (
              <h3>{t('fichaAviso.busquedasRelacionadas.emptyState')}</h3>
            ) : (
              <LinksContainer>
                {busquedasRelacionadas.map(({ titulo, link }) => {
                  return (
                    <Li key={`${titulo}_${link}`}>
                      <Link href={link}>
                        <LinkTitle>{titulo}</LinkTitle>
                      </Link>
                    </Li>
                  )
                })}
              </LinksContainer>
            )}
          </Col>
        </Row>
      </MainContainer>
    </RelacionadasContainer>
  )
}

const states = ({ activeAvisoStore }) => ({
  activeAviso: activeAvisoStore,
  activeAvisoStates: activeAvisoStore.activeAvisoStates,
})

export default connect(states)(BusquedasRelacionadas)
